export enum FeatureFlags {
  ENABLE_REINSTATEMENT_CC_LINKS = 'enable-reinstatement-cc-links',
  ENABLE_FORECASTED_FILING_CARDS = 'enable-forecasted-filing-cards',
  ENABLE_AMENDMENT_ROUTING = 'enable-amendment-routing',
  ENABLE_TEMPLATE_STORE = 'enable-template-store',
  ENABLE_MYLZ_CHAT = 'enable-rex-chat',
  ENABLE_MYLZ_DEFERRED_DATA = 'enable-deferred-data',
  ENABLE_MYLZ_HYDRATION_DELAY = 'deferdebug-enable-hydration-delay',
  ENABLE_MYLZ_TRACKING_SCRIPTS = 'deferdebug-enable-tracking-scripts',
  ENABLE_ORCO_CHAT_BOT = 'enable-orco-chat-bot',
  ENABLE_ORDER_STATUS_BOT_CHAT = 'enable-order-status-bot-chat',
  ENABLE_EXPANDED_SOS = 'enable-expanded-sos',
  ENABLE_SELF_SERVE_ORCO = 'enable-self-serve-orco',
  ENABLE_SELF_SERVE_RESOLUTIONS = 'enable-self-serve-resolutions',
  ENABLE_SELF_SERVE_EXCEPTIONS = 'enable-self-serve-exceptions',
  ENABLE_SOS_ADDRESS_SELF_SERVE_ORCO = 'enable-sos-address-self-serve-orco',
  ENABLE_SOS_NAME_SELF_SERVE_ORCO = 'enable-sos-name-self-serve-orco',
  ENABLE_SUB_CANCELLATION_V_2 = 'enable-sub-cancellation-v-2',
  ENABLE_TAX_EXTENSION_TY2023 = 'tax-extensions-ty-2023',
  ENABLE_AUTO_ASSIGN_REVIEWER = 'enable-auto-assign-reviewer',
  ENABLE_SELF_SERVE_ORCO_PROF_DOCUMENT_UPLOAD = 'enable-self-serve-orco-prof-document-upload',
  ENABLE_REMIX_ISLAND = 'enable-remix-island',
  ENABLE_STREAMLINE_CONSULTATION_APPLICATION_ROUTING = '86a3wmzbk-enable-streamline-consultation',
  ENABLE_TAX_GTM = 'expert-5017-enable-tax-upsell-upgraded-design',
  ENABLE_BENEFICIAL_OWNERSHIP_INFORMATION_REPORT = 'enable-beneficial-ownership-report',
  ENABLE_BL_UPLOAD_FUNCTIONALITY = 'enable-bl-upload-functionality',
  ENABLE_BL_SHARE_LICENSE = 'enable-bl-share-license',
  ENABLE_BL_SUBSCRIPTION_TAKEOVERS = 'enable-bl-subscription-takeovers',
  ENABLE_BL_SUBSCRIPTION_PRODUCT = 'enable-bl-subscription-product',
  BL_QUESTIONNAIRE_CONSOLIDATION = 'bl-questionnaire-consolidation',
  BL_AUTOGENERATE_REPORT = 'bl-autogenerate-report',
  ENABLE_ORDERS_TABLE_IN_PERSONAL = 'enable-orders-table-in-personal',
  EXPERT_5036_ENABLE_TAX_GTM_PRE_SEASON_BUZZ = 'expert-5036-enable-tax-gtm-pre-season-buzz',
  EXPERT_5036_ENABLE_TAX_GTM_PROMO_ANNOUNCEMENT = 'expert-5036-enable-tax-gtm-promo-announcement',
  EXPERT_5036_ENABLE_TAX_GTM_OFFER_ENDS_SOON = 'expert-5036-enable-tax-gtm-offer-ends-soon',
  EXPERT_5036_ENABLE_TAX_GTM_OFFER_EXTENDED = 'expert-5036-enable-tax-gtm-offer-extended',
  EXPERT_5036_ENABLE_TAX_GTM_GET_TAXES_DONE = 'expert-5036-enable-tax-gtm-get-taxes-done',
  ENABLE_CTA_ANALYTICS = 'cta-analytics',
  ENABLE_WORKSPACE_PICKER_FOR_EIN_ORDER = 'enable-workspace-picker-for-EIN-order',
  ENABLE_RA_ATTORNEY_ASSIST = 'enable-ra-attorney-assist',
  ENABLE_BENEFICIAL_OWNERSHIP_INFORMATION_REPORT_MVP = 'enable-beneficial-ownership-information-report-mvp',
  ENABLE_AUTO_FILE_OPT_IN = 'enable-auto-file-opt-in',
  ENABLE_LIMITING_DUPLICATE_TAX_PURCHASES = 'enable-limiting-duplicate-tax-purchases',
  SHOW_501C3_MESSAGE = 'show-501-c-3-message',
  ENABLE_ABILITY_TO_SELL_STANDALONE_BAP = 'enable-ability-to-sell-standalone-bap',
  ENABLE_WIDGETS_V2 = 'enable-home-v2-widgets',
  ENABLE_BUSINESS_INSIGHTS_WIDGETS = 'enable-business-insights-widgets',
  ENABLE_BOOKS_INVOICE_HOME_WIDGET = 'enable-books-invoice-home-widget',
  ENABLE_BOOKS_EXPENSE_HOME_WIDGET = 'enable-books-expense-home-widget',
  ENABLE_BOOKS_PROFIT_HOME_WIDGET = 'enable-books-profit-home-widget',
  ENABLE_BOOKS_TASKS = 'enable-books-tasks',
  ENABLE_BOOKS_INVOICE_EMAIL_TEMPLATE = 'books-invoice-email-template',
  ENABLE_BOOKS_COLUMN_TAX = 'enable-books-column-tax',
  ENABLE_BOOKS_1_YEAR_20_OFF_OFFER = 'enable-books-1-year-20-off-offer',
  ENABLE_VIRTUAL_MAIL_HOME_WIDGET = 'enable-virtual-mail-home-widget',
  ENABLE_TAX_EXPERT_WIDGET_IN_BOOKS_OVERVIEW = 'enable-tax-expert-widget-in-books-overview',
  ENABLE_TAX_SMS_NOTIFICATIONS = 'enable-tax-sms-notifications',
  ENABLE_GTKY_IQ = 'enable-gtky-iq',
  ENABLE_GTKY_ON_IQ_BOIR = 'enable-gtky-on-iq-boir',
  ENABLE_COMMERCE_2_ESIGN_OFFER = 'commerce-2-esign-offer',
  EXPERT_5142_ENABLE_TAX_ONBOARDING_WORK_ITEM = 'expert-5142-enable-tax-onboarding-work-item',
  ENABLE_PROGRESS_BAR_FOR_PRENUP = 'show-prenup-page',
  EXPERT_5166_TAX_PLAN_PRICE_CHANGES = 'expert-5166-tax-packages-price-change',
  ENABLE_COMMON_PUBLIC_ROUTE = 'enable-common-public-route',
  GOOGLE_WORKSPACE_ANNUAL_SUBSCRIPTION = 'google-workspace-annual-subscription',
  ENABLE_ALTM_TRACKER = 'enable-altm-tracker',
  ENABLE_TIMEWARP_PAYMENT_HISTORY = 'enable-timewarp-payment-history',
  ENABLE_TIMEWARP_GET_SUBSCRIPTIONS = 'enable-timewarp-get-subscriptions',
  ENABLE_TIMEWARP_BOOKS = 'enable-timewarp-books',
  ENABLE_GENERIC_MESSAGING = 'enable-generic-messaging',
  ENABLE_TAX_ENTITLEMENT_OVERRIDE = 'enable-tax-entitlement-override',
  APP_CONFIG_OFF_SEASON_TAX_DUE_DATES = 'app-config-off-season-tax-due-dates',
  APP_CONFIG_CONFIRM_CONSULT_MODAL = 'app-config-confirm-consult-modal',
  ENABLE_BAP_PLANS_INSIDE_FORMS_ESIGN_BILLING = 'enable-bap-plans-inside-forms-esign-billing',
  ENABLE_DYNAMIC_PRICE_IN_TAX_PLAN_CARDS = 'enable-dynamic-price-in-tax-plan-cards',
  ENABLE_STRIKETHROUGH_PRICE_IN_TAX_PLANS = 'enable-strikethrough-price-in-tax-plans',
  EXPERT_ENABLE_AMENDED_TAX_PREP_WORK_ITEM = 'expert-enable-amended-tax-prep-work-item',
  EXPERT_ENABLE_QUARTERLY_TAX_ESTIMATE_WORK_ITEM = 'expert-enable-quarterly-tax-estimate-work-item',
  ENABLE_BRAND_ALTM = 'enable-brand-menu',
  ENABLE_SELF_SERVE_ORCO_EIN = 'enable-self-serve-orco-ein',
  ENABLE_NEW_BOIR = 'enable-new-boir',
  ENABLE_BOIR_FILING_PROOF = 'boir-filing-proof',
  ENABLE_CONSULTATION_SMS = 'expert-sms-notification-for-consultations',
  EXPERT_ENABLE_ENTITY_ELECTION_WORK_ITEM = 'expert-enable-entity-election-work-item',
  EXPERT_ENABLE_TAX_INVESTIGATION_WORK_ITEM = 'expert-enable-tax-investigation-work-item',
  EXPERT_ENABLE_HIDE_TAX_TAB = 'expert-enable-hide-tax-tab',
  ENABLE_BOOKS_HIDE_TAX = 'enable-books-hide-tax',
  ENABLE_EXPERT_PROGRESS_TRACKER_EARLIER_CONSULT = 'enable-expert-progress-tracker-earlier-consult',
  ENABLE_TAX_PENALTIES_AND_INTEREST_WORK_ITEM_TRACKER = 'enable-tax-penalties-and-interest-work-item-tracker',
  ENABLE_ESIGN_ORDERS_IN_LEGACY_ORDERS_PAGE = 'enable-esign-orders-in-legacy-orders-page',
  ENABLE_BOIR_SPECIAL_OFFER_JUN_24 = 'enable-boir-special-offer-jun-24',
  ENABLE_FULFILLMENT_SSORCO_ENDPOINT = 'enable-fulfillment-ssorco-endpoint',
  SHOW_DESIGNATED_ATTORNEY_EXPERT = '86a3x587r-show-attorney-designated-expert',
  ENABLE_SHARE = 'enable-share-button-for-bl',
  ENABLE_ACCOUNT_TOOLS = 'enable-account-tools',
  ENABLE_NAME_CHANGE_TRACKER = 'enable-name-change-progress-tracker',
  ENABLE_LEGAL_DISCOVERY = 'legal-store-in-legal-centre',
  ENABLE_ESTATE_PLANNING_V2 = 'enable-estate-planning-v2',
  ENABLE_WILL_SUBSCRIPTIONS = 'enable-will-subscriptions',
  ENABLE_TAX_PREP_STREAMLINE_CONSULTATION = 'enable-tax-prep-streamline-consultation',
  ENABLE_LEGAL_STREAMLINE_CONSULTATION = 'enable-legal-streamline-consultation',
  ENABLE_PRENUP_DEFAULT_PROGRESS_TRACKER = 'enable-prenup-default-progress-tracker',
  ENABLE_FORMS_ESIGN_ACTIVATION = 'enable-forms-esign-activation',
  ENABLE_UNIVERSAL_CHECKOUT_SHIPPING_ADDRESS = 'enable-universal-checkout-shipping-address',
  ENABLE_AAF_NEW_CONSULTATION_FLOW = 'collaboration-enable-aaf-new-consultaiton-flow',
  ENABLE_AAF_TASK_EXPRESS_GOLD_INC = 'enable-aaf-task-gold-inc',
  ENABLE_UNIVERSAL_CHECKOUT_CONTACT_FIELDS = 'enable-universal-checkout-contact-fields',
  ENABLE_LEGAL_AGREEMENTS_REMIX = 'enable-legal-agreement-remix',
  ENABLE_LEGAL_AGREEMENTS_SKIP_7216 = 'enable-legal-agreements-skip-7216',
  ENABLE_LEGAL_AGREEMENTS_PARTNER_LOGO_BUILDER = 'enable-legal-agreements-partner-logo-builder',
  ENABLE_AI_ASSISTANT_LEGAL_CENTRE = 'enable-ai-assistant-legal-centre',
  ENABLE_WORKSPACE_REMOVAL = 'enable-workspace-removal',
  ENABLE_QUALTRICS_SNIPPET = 'qualtrics-snippet',
  ALLOW_TOKENIZE_PAYMENTS_IN_UNIVERSAL_CHECKOUT = 'allow-tokenize-payments-in-universal-checkout',
  ENABLE_STREAMLINE_RESCHEDULING = 'enable-streamline-reschedule-consultation',
  ENABLE_TRADEMARK_STREAMLINE_CONSULTATION = 'enable-trademark-streamline-consultation',
  ENABLE_RESCHEDULE_SYNC = 'enable-reschedule-ecp-consultation',
  UNIVERSAL_CHECKOUT_PROMO_CODES = 'universal-checkout-coupon-codes',
  ENABLE_LEGAL_MESSAGING = 'enable-legal-messaging',
  ENABLE_REDESIGNED_LEGAL_CENTER = 'enable-redesigned-legal-center',
  HOME_BOOKS_BANNER = 'home-books-banner',
  ENABLE_ALTM_PRICING_TEST = 'exp-altm-pricing-test',
  ENABLE_FREE_CF_UPSELL = 'enable-free-cf-upsell',
  ENABLE_MINI_BP_TRANSITION = 'enable-mini-bp-transition',
  ENABLE_MOBILE_PAY_IN_UNIVERSAL_CHECKOUT = 'enable-mobile-pay-in-universal-checkout',
  ENABLE_BOIR_NEW_ENTRY = 'enable-boir-new-entry',
  ENABLE_TAX_PREP_2024 = 'enable-tax-prep-2024',
  ENABLE_PROMO_PRICING_CARDS = 'enable-promo-pricing-cards',
  ENABLE_EP_NEW_YEAR_PROMO_BANNER = 'enable-ep-new-year-promo-banner',
  ENABLE_ECP_CONSULTATIONS_PHASE_2 = 'enable-ecp-consultations-phase-2',
  DISABLE_TN_LEGAL_PLAN_RESTRICTIONS = 'disable-tn-legal-plan-restrictions',
  ENABLE_FORYOU_V2 = 'enable-foryou-v2',
  ACTIVATION_SAVEDFORLATER_AB_TEST = 'activation-savedforlater-ab-test',
  ENABLE_ESIGN_FORM_WITH_NEW_COMMERCE_2 = 'enable-esign-form-with-new-commerce-2',
  ENABLE_EP_NEW_YEAR_PROMO_BANNER_EXTENDER = 'enable-ep-new-year-promo-banner-extended',
  ENABLE_DISSOLUTION_IQ = 'enable-dissolution-iq',
  ENABLE_BP_PROCESSING_ORDER_FIX = 'enable-bp-processing-order-fix',
  ENABLE_MODIFYING_GTKY_FLOWS = 'enable-modifying-gtky-flows',
  ENABLE_GET_COMMERCE_ENTITLEMENTS_BFF = 'enable-get-commerce-entitlements-bff',
  ENABLE_COMMERCE_2_SUBSCRIPTION = 'enable-get-commerce-entitlements',
  IS_BOIR_REQUIRED = 'is-boir-required',
  ENABLE_CLEAR_CART_IN_UNIVERSAL_CHECKOUT = 'enable-clear-cart-in-universal-checkout',
  ENABLE_TRADEMARK_ORDERS_QUERY = 'enable-trademark-orders-query',
  ENABLE_INITIAL_REPORT_PRICE_CHANGE = 'enable-initial-report-price-change',
  ENABLE_TAX_RETURN_TASK_DUE_DATE = 'enable-tax-return-task-due-date',
  ENABLE_QUALTRICS_SNIPPET_BUSINESS_ONLY = 'qualtrics-snippet-business-only',
  ENABLE_FORMATIONS_EIN = 'enable-formations-ein',
  ENABLE_FULFILLMENT_EIN_PREP_ONLY = 'enable-fulfillment-ein-prep-only',
  ENABLE_THREE_PAY_IN_UNIVERSAL_CHECKOUT = 'enable-three-pay-in-universal-checkout',
  ENABLE_DBA_AS_ATTACH = 'enable-dba-as-attach',
  ENABLE_TASK_UPDATE_FROM_ORDER_STATUS = 'enable-task-update-from-order-status',
  ENABLE_STANDALONE_PAYMENT_HISTORY_PAGE = 'enable-standalone-payment-history-miniapp',
  ENABLE_IQ_FLOW_CERTIFICATES_OF_GOOD_STANDING = 'enable-iq-flow-certificates-of-good-standing',
  ENABLE_EP1_TO_EP2_MIGRATION_FLOW = 'enableEp1ToEp2MigrationFlow',
  ENABLE_IQ_FLOW_FOREIGN_QUALIFICATION = 'enable-iq-flow-foreign-qualification',
  ENABLE_NONPROFIT_HOME_ENHANCEMENTS = 'enable-nonprofit-home-enhancements',
  ENABLE_NONPROFIT_TASK_LIST = 'enable-nonprofit-task-list',
  ENABLE_IQ_FLOW_OPERATING_AGREEMENT = 'enable-iq-flow-operating-agreement',
  ENABLE_IQ_FLOW_BYLAWS = 'enable-iq-flow-bylaws',
  ENABLE_501c3_TASKS = 'enable-501c3-tasks',
  ENABLE_TASK_LIST_FOR_TEST_ORDER_TAG = 'enable-task-list-for-test-order-tag',
  ENABLE_FTC_CHECKBOX_MY_LZ_CHECKOUTS = 'enable-ftc-checkbox-mylz-checkouts',
  ENABLE_FQ_CONCIERGE_QUESTIONNAIRE = 'enable-fq-concierge-questionnaire',
  ENABLE_NMAWM_BANNER = 'nmawm-enable-banner',
  ENABLE_NMAWM_BANNER_EXTENSION = 'nmawm-banner-extension',
  ENABLE_COMPLIANCE_AGENT_DIRECTORY = 'enable-compliance-agent-directory',
  STATES_WITH_ACTIVE_AUTOFILE = 'states-with-active-autofile',
  ENABLE_MYLZ_HOME_AI_ASSISTANT = 'enable-mylz-home-ai-assistant',
  DISABLE_CHARGEBEE_SCRIPT_DEBUGGING = 'disable-chargebee-script-debugging',
  ENABLE_DIFM_DISSOLUTION_WORKFLOW_TRACKER = 'enable-difm-dissolution-workflow-tracker',
  ENABLE_FQ_ORDER_TRACKER = 'enable-fq-order-tracker',
  ENABLE_LLC_HOME_PERSONALIZATION = 'enableLlcHomePersonalization',
  ENABLE_PATENT_AI_WIDGET = 'enable-patent-ai-widget',
  ENABLE_EP_APP_REDIRECT = 'enableEPAppRedirect',
  ENABLE_EP_USER_FEEDBACK_RATING = 'ep-user-feedback-rating',
  ENABLE_EP_LEGACY_MAP = 'ep-legacy-map',
  ENABLE_1800_WEBINAR_BANNER = 'enable-1800-webinar-banner',
  EXP_1800_TAKEOVER_PAGE = 'exp-1800-takeover-page',
  AR_SUBSCRIPTION_LINEUP_AB_TEST = 'exp-ar-subscription-lineup-test',
  ENABLE_AR_SUBSCRIPTION_LINEUP = 'enable-ar-subscription-lineup',
  ENABLE_IR_SUBSCRIPTION_LINEUP = 'enable-ir-subscription-lineup',
  ENABLE_STATE_PRINT_AND_SHIP_ENHANCEMENT = 'enable-state-print-and-ship-enhancement',
  ENABLE_TIME_WARP_SUBSCRIPTION_REACTIVATION = 'enable-time-warp-subscription-reactivation',
  ENABLE_CREDIT_LADDER_DISCOVERY_CARD = 'enable-creditladder-discovery-card',
  ENABLE_PARTNERSHIPS_BFF_BYPASS = 'enable-partnerships-bff-bypass',
  ENABLE_DOCS_SENT_MERCURY = 'banking-docs-sent-mercury',
  ENABLE_MERCURY_EMBEDDED_SIGNUP = 'enable-mercury-embedded-signup',
  ENABLE_EP2_TRACK_SHIPMENT = 'enableEp2TrackShipment',
  ENABLE_DYNAMIC_TABLE_IN_FORMS = 'enable-dynamic-table-in-forms',
  ENABLE_AI_ASSISTANT_FEEDBACK = 'enable-ai-assistant-feedback',
  ENABLE_1800_TAX_RETURN_TASK = 'enable-1800-tax-return-task',
  ENABLE_FILING_FEE_CALL_TO_IP = 'enable-filing-fee-to-call-ip',
  ENABLE_FULFILLMENT_MESSAGING = 'enable-fulfillment-messaging',
  ENABLE_ATTORNEY_CONSULT_SCHEDULING_PROD = 'enable-attorney-consult-scheduling-prod',
  HACKATHON_GROUP_18 = 'hackathon-group-18',
  ENABLE_UNIVERSAL_CHECKOUT_GUEST_SESSION = 'enable-universal-checkout-guest-session',
  ENABLE_CONFIGURABLE_CHECKOUT_TAKEOVER = 'enable-configurable-checkout-takeover',
  ENABLE_REDT_IQ_FLOW = 'enableRedtIqFlow',
  ENABLE_PAYPAL_PAYMENT_METHOD = 'enable-paypal-payment-method',
  ENABLE_LWT_BUNDLE_UPGRADE = 'enableLWTBundleUpgrade',
  ENABLE_EXPERT_ACCESS_HOME = 'enable-expert-access-home',
  ENABLE_EXPERT_ACCESS_SCHEDULE_DIALOG = 'enable-expert-access-schedule-dialog',
  ENABLE_EXPERT_ACCESS_CONCIERGE_SCHEDULE_DIALOG = 'enable-expert-access-concierge-schedule-dialog',
  ENABLE_EXPERT_ACCESS_IN_MODAL_PROFILE = 'enable-expert-access-in-modal-profile',
  AD_HOC_MESSAGING_EXPERT_SHORTCUT = 'ad-hoc-messaging-expert-shortcut',
  ENABLE_MEETING_MINUTES = 'enable-meetings-minutes',
  ENABLE_COMMERCE_SUBSCRIPTIONS_SERVICE_CACHE = 'enable-commerce-subscriptions-service-cache',
  ENABLE_BULK_DOWNLOAD_DOC_CENTER = 'enableBulkDownloadDocCenter',
  ENABLE_DOC_CENTER_THUMBNAILS = 'enableDocCenterThumbnails',
  ENABLE_TRASH_DOC_CENTER = 'enableTrashDocCenter',
  ENABLE_GUARDIAN_RISK_ASSESSMENT = 'enable-guardian-risk-assessment',
  ENABLE_DOC_CENTER_DOCUMENT_HISTORY = 'enableDocCenterDocumenthistory',
  ENABLE_DOC_CENTER_NEW_UI_REFRESH = 'enableDocCenterNewUIRefresh',
  ENABLE_DOC_CENTER_FOLDER_PATHS = 'enableDocCenterFolderPaths',
  ENABLE_DOC_CENTER_BOOKMARKS = 'enableDocCenterBookmarks',
  ENABLE_SIGNATURE_COLLECTION_HOME_ORDER_TRACKER = 'enable-signature-collection-home-order-tracker',
  ENABLE_COMPLIANCE_CONCIERGE_SCHEDULING = 'enable-compliance-concierge-scheduling',
  ENABLE_STANDALONE_SCORP = 'enable-standalone-scorp',
  ENABLE_FOREIGN_QUALIFICATION_ONBOARDING_SCHEDULING = 'enable-foreign-qualification-onboarding-scheduling',
  ENABLE_WORKER_CLASSIFICATION_TOOL = 'enable-worker-classification-tool',
  ENABLE_SKIP_CHECKOUT_CONFIRMATION = 'enable-skip-checkout-confirmation',
  ENABLE_AI_CONTRACTS = 'enable-ai-contracts',
  ENABLE_TIMEWARP_LEGACY_CARD_CREATION = 'enable-timewarp-legacy-card-creation',
  ENABLE_SMS_MAGIC_LINK = 'enable-sms-magic-link',
}
